module.exports = __webpack_public_path__ + "static/media/appstore.bc924222.png";